import { Link } from "react-router-dom";
import { useNavigationFeedback } from "../contexts/NavigationFeedbackContext";

export default function FeedbackLink({ onClick, target, ...props }) {
  const { startNavigation } = useNavigationFeedback();

  const handleClick = (event) => {
    onClick?.(event);

    if (
      event.defaultPrevented ||
      target === "_blank" ||
      event.button !== 0 ||
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey
    ) {
      return;
    }

    startNavigation();
  };

  return <Link {...props} target={target} onClick={handleClick} />;
}
